import { Box, Button } from "native-base";
import styled from "styled-components/native";

export const Container = styled(Box)``;

export const GetStartedButton = styled(Button)`
  background-color: #ffe040;
  width: 60px;
  height: 60px;
  border-radius: 50px;
`;
